/**
@format
@flow
*/
import type { MongoIdType } from '@ziynx/flow-types/globals';

const isDev: boolean = process.env.REACT_APP_DEVELOPMENT === 'true';

type EmploymentType = {
  value: string,
  name: string,
  _id?: MongoIdType,
};

const DEV_EMPLOYMENT_TYPES: Array<EmploymentType> = [
  {
    value: '',
    name: '',
  },
  {
    value: '618430d2181c9a2d5acb31da',
    name: 'Entry level',
  },
  {
    value: '61819dd43c8d690008ca43b8',
    name: 'Internship',
  },
];

const PROD_EMPLOYMENT_TYPES: Array<EmploymentType> = [
  {
    value: '',
    name: '',
  },
  {
    value: '6184312382afac90dfff5bfd',
    name: 'Entry level',
  },
  {
    value: '6182d6c80f7eb00009d146fe',
    name: 'Internship',
  },
];

// eslint-disable-next-line max-len
const EMPLOYMENT_TYPES: Array<EmploymentType> = isDev ? DEV_EMPLOYMENT_TYPES : PROD_EMPLOYMENT_TYPES;

export { EMPLOYMENT_TYPES };
